define.alias("shared/components/shared/video-player", "calendar/components/shared/video-player");